import { createFileRoute, redirect } from '@tanstack/react-router'
import { Alert, Flex } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CampaignClientsSection } from '../campaign/components/settings/campaign-clients-section'
import { INDEX_CLIENT } from '../user/permission'

export const Route = createFileRoute('/_auth/_main/campaigns/$campaignId/settings/clients')({
    beforeLoad: ({ context }) => {
        if (!context.auth.can(INDEX_CLIENT)) {
            throw redirect({ to: '/dashboard' })
        }
    },
    component: CampaignSettingsClients,
})

function CampaignSettingsClients() {
    const { campaignId } = Route.useParams()
    const { t } = useTranslation()

    return (
        <Flex
            vertical
            gap="large"
        >
            <Alert
                type="info"
                showIcon
                message={t('Access changes take effect immediately. You do not need to save.')}
            />
            <CampaignClientsSection campaignId={campaignId} />
        </Flex>
    )
}
